import { config as shopsConfig } from './shops.config';
import { config as partnersConfig } from './partners.config';
import { config as selectDateConfig } from './select-date.config';
import { config as aboutYouConfig } from './about-you.config';
import { config as completeConfig } from './complete-page.config';
import { config as pathConfig } from './path.config';
import { config as remoteConfig } from './remote.config';
import { config as reviewConfig } from './review.config';
import { getAppointmentsDetails } from './analytics.config';
import { PROGRESS_BAR_ITEMS, EDIT_PROGRESS_BAR_ITEMS } from './progress-bar-items.config';
import {
  ChosenPartner,
  HAIR_SKIN_EYES,
} from '~/components';
import styles from '~/components/questions/question/Question.scss';
import { config as errorConfig } from './error-handler.config';
import { createHeadline } from '~/ocab-services/beauty-society/config/headline.config';
import { services } from '../../services.constant';

const questionsSectionsConfig = [
  {
    key: HAIR_SKIN_EYES,
    title: 'Hair, skin and eye colour',
    dataTest: 'HairAndEyes',
    extraClassName: styles.HairAndEyeColour,
    url: 'hair-skin-and-eye-colour',
  },
  {
    key: undefined,
    title: 'Additional information',
    dataTest: 'AdditionalInformation',
    url: 'additional-information',
  },
];

export const config = {
  ...shopsConfig,
  ...partnersConfig,
  ...selectDateConfig,
  ...aboutYouConfig,
  ...completeConfig,
  ...completeConfig,
  ...pathConfig,
  ...reviewConfig,
  serviceName: services.BEAUTY_SOCIETY.name,
  getAppointmentsDetails,
  chosenPartner: ChosenPartner,
  defaultPartnerText: 'I don\'t mind which Beauty Guide I see',
  isPartnerSelectionEnabled: true,
  partnerPrefix: 'Partner & ',
  partnerTitle: 'Beauty Guide',
  PROGRESS_BAR_ITEMS,
  EDIT_PROGRESS_BAR_ITEMS,
  questionsSectionsConfig,
  headlineTitle: createHeadline,
  errorConfig,
  remote: remoteConfig,
};
